import { render, staticRenderFns } from "./InstructorWarningsPage.vue?vue&type=template&id=5cba4b81"
import script from "./InstructorWarningsPage.vue?vue&type=script&lang=js"
export * from "./InstructorWarningsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports